import { createContext, PropsWithChildren, ReactElement, useContext } from 'react'

import { useAttachmentsUpload } from '../hooks/useAttachmentsUpload'
import { Attachment } from '../types/attachment'

interface ContextState {
  attachments: Attachment[]
  attachmentUuids: string[]
  cancelUpload: (id: string) => void
  hasFailedAttachments: boolean
  isDeleting: boolean
  isUploading: boolean
  removeAttachment: (id: string) => void
  retryUpload: (id: string) => void
}

const AttachmentsUploadManagerContext = createContext<ContextState | undefined>(undefined)

type AttachmentsUploadManagerContextProviderProps = PropsWithChildren

export const AttachmentsUploadManagerContextProvider = ({
  children,
}: AttachmentsUploadManagerContextProviderProps): ReactElement => {
  const {
    attachments,
    attachmentUuids,
    cancelUpload,
    hasFailedAttachments,
    isDeleting,
    isUploading,
    removeAttachment,
    retryUpload,
  } = useAttachmentsUpload()

  return (
    <AttachmentsUploadManagerContext.Provider
      value={{
        attachments,
        attachmentUuids,
        cancelUpload,
        hasFailedAttachments,
        isDeleting,
        isUploading,
        removeAttachment,
        retryUpload,
      }}
    >
      {children}
    </AttachmentsUploadManagerContext.Provider>
  )
}

export const useAttachmentsUploadManager = () => {
  const context = useContext(AttachmentsUploadManagerContext)

  if (!context) {
    throw new Error('AttachmentsUploadManagerContextProvider is missing in the module!')
  }

  return context
}
